/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ScheduleOptions/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ScheduleOptions({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/ScheduleOptions"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentOverlayAppointmentTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_type_id',
})
let appointmentOverlayDurationValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'duration',
})
let aggregateData = fromAggregate.and(appointmentOverlayAppointmentTypeIdValueData, appointmentOverlayDurationValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}